import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  AportacionDIEstadoControllerService,
  AportacionDIPoseedorControllerService,
  AportacionDisddrcaControllerService,
  SolicitudNimaGestoresDTO,
  SolicitudNimaPoseedorDTO
} from 'api-rest';
import { Subscription, map } from 'rxjs';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import {SpinnerService} from "../../../services/spinner.service";
import {SnackbarService} from "../../../services/snackbar.service";

@Component({
  selector: 'app-open-sddr-contributions-dis-selection-dialog',
  templateUrl: './open-sddr-contributions-dis-selection-dialog.component.html',
  styleUrls: ['./open-sddr-contributions-dis-selection-dialog.component.scss'],
})
export class OpenSddrContributionsDisSelectionDialogComponent implements OnInit {
  nimaGestorArray: any[] = [];
  nimaPoseedorArray: any[] = [];
  entityRoles: any[] = [];

  modelForm: FormGroup;
  roleEntities: any[] = [];
  isGestor = false;
  isPoseedor = false;

  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private dialogRef: MatDialogRef<OpenSddrContributionsDisSelectionDialogComponent>,
    private estadoAportacionesService: AportacionDIEstadoControllerService,
    private aportacionesDiService: AportacionDIPoseedorControllerService,
    private aportacionesDiSDDRCAService: AportacionDisddrcaControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService
  ) {
    this.modelForm = this.formBuilder.group({
      fechaAceptacion: [{ value: null, disabled: false }],
      acondicionador: [{ value: null, disabled: false }],
      poseedor: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      isPoseedor: [{ value: null, disabled: false }],
      isGestor: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.roleEntities = (this.authService.user as any).roleEntities;

    const rolesGestor = this.roleEntities.filter(
      (roleEntity) => roleEntity.role == 'PO-GESTOR'
    );
    const rolesPoseedor = this.roleEntities.filter(
      (roleEntity) => roleEntity.role == 'PO-POSEEDOR'
    );

    if (rolesGestor.length > 0) {
      this.isGestor = true;
      this.modelForm.get('isGestor')?.setValue(true);
      this.buscarNimaGestor();
    } else if (rolesPoseedor.length > 0) {
      this.isPoseedor = true;
      this.modelForm.get('isPoseedor')?.setValue(true);
      this.buscarNimaPoseedor();
    }
    
    this.estadoAportacionesService
      .findAll14()
      .pipe(map((estados) => estados.find((estado) => estado.id === 1)))
      .subscribe((estado) => {
        if (estado) {
          this.modelForm.get('estado')?.setValue(estado);
        }
      });
  }

  buscarNimaGestor() {
    const filtroNimaGestor: SolicitudNimaGestoresDTO = {
      fechaAceptacion: this.modelForm.value?.fechaAceptacion,
      estadoGestorCompletado: true
    };

    this.aportacionesDiSDDRCAService
      .nimaGestores(filtroNimaGestor)
      .subscribe((res) => (this.nimaGestorArray = res));
  }

  buscarNimaPoseedor() {
      const filtroNimaPoseedor: SolicitudNimaPoseedorDTO = {
        fechaAceptacion: this.modelForm.value?.fechaAceptacion,
      };
  
      this.aportacionesDiService
        .nimaPoseedores(filtroNimaPoseedor)
        .subscribe((res) => (this.nimaPoseedorArray = res));
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  seleccionar() {
    if (this.canSelectionPoseedor() || this.canSelectionGestor()) {
      this.dialogRef.close(this.modelForm.value);
    } else {
      this.snackBarSrv.showSnackBar('Debe seleccionar un Nima', 'error');
    }
  }

  showClearButton(formName: string): boolean {
    return this.modelForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.modelForm.get(formName)?.setValue(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.modelForm.controls[controlName].hasError(errorName) &&
      this.modelForm.controls[controlName].touched
    );
  }

  canSelectionPoseedor(): boolean {
    return this.modelForm.get('poseedor')?.value != null;
  }

  canSelectionGestor(): boolean {
    return this.modelForm.get('acondicionador')?.value != null;
  }
}
